import axios from 'axios'
import authHeader from './auth-header'
import Config from '../../config'
import Vue from 'vue';

if (localStorage.getItem('gpsServers')) {
    Vue.prototype.$gpsServers = JSON.parse(localStorage.getItem('gpsServers'))
} else {
    Vue.prototype.$gpsServers = Config.gpsServers
}
if (localStorage.getItem('apiServers')) {
    Vue.prototype.$apiServers = JSON.parse(localStorage.getItem('apiServers'))
} else {
    Vue.prototype.$apiServers = Config.apiServers
}
const serverAddress = `${Vue.prototype.$apiServers.url}/admin`

class ServerService {
  // eslint-disable-next-line class-methods-use-this
  getList() {
    const promise = axios.post(`${Vue.prototype.$apiServers.url}/admin/server/list`, { }, { headers: authHeader() })
    return promise.then(response => response.data)
  }

  // eslint-disable-next-line class-methods-use-this
  getById(data) {
    const promise = axios.post(`${Vue.prototype.$apiServers.url}/admin/server/byId`, { id: data.id }, { headers: authHeader() })
    return promise.then(response => response.data)
  }

  // eslint-disable-next-line class-methods-use-this
  add(data) {
    const promise = axios.post(`${Vue.prototype.$apiServers.url}/admin/server/add`,
      data, { headers: authHeader() })

    return promise.then(response => response.data)
  }

  // eslint-disable-next-line class-methods-use-this
  update(data) {
    const promise = axios.post(`${Vue.prototype.$apiServers.url}/admin/server/update`,
      {
        // eslint-disable-next-line no-underscore-dangle
        id: data._id,
        title: data.title,
        protocol: data.protocol,
        port: data.port,
      }, { headers: authHeader() })

    return promise.then(response => response.data)
  }

  // eslint-disable-next-line class-methods-use-this
  delete(data) {
    const promise = axios.post(`${Vue.prototype.$apiServers.url}/admin/server/delete`,
      {
        data: {
          // eslint-disable-next-line no-underscore-dangle
          _id: data._id,
        },
        headers: authHeader(),
      })
    return promise.then(response => response.data)
  }
}

export default new ServerService()
